/* tslint:disable */
/* eslint-disable */
/**
 * Dataland Backend API documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../../../../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../../../../../base';
// @ts-ignore
import type { DataPointMetaInformation } from '../../../../../../org/dataland/datalandfrontend/openApiClient/backend/model';
// @ts-ignore
import type { DataPointToValidate } from '../../../../../../org/dataland/datalandfrontend/openApiClient/backend/model';
// @ts-ignore
import type { ErrorResponse } from '../../../../../../org/dataland/datalandfrontend/openApiClient/backend/model';
// @ts-ignore
import type { UploadedDataPoint } from '../../../../../../org/dataland/datalandfrontend/openApiClient/backend/model';
/**
 * DataPointControllerApi - axios parameter creator
 */
export const DataPointControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * A data point identified by its ID is retrieved.
         * @summary Retrieve data points by ID.
         * @param {string} dataPointId The unique identifier of the datapoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataPoint: async (dataPointId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataPointId' is not null or undefined
            assertParamExists('getDataPoint', 'dataPointId', dataPointId)
            const localVarPath = `/data-points/{dataPointId}`
                .replace(`{${"dataPointId"}}`, encodeURIComponent(String(dataPointId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Meta-information about a data point identified by its ID is retrieved.
         * @summary Retrieve meta-information about data points by ID.
         * @param {string} dataPointId The unique identifier of the datapoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataPointMetaInfo: async (dataPointId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataPointId' is not null or undefined
            assertParamExists('getDataPointMetaInfo', 'dataPointId', dataPointId)
            const localVarPath = `/data-points/{dataPointId}/metadata`
                .replace(`{${"dataPointId"}}`, encodeURIComponent(String(dataPointId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The uploaded data point is added to the data store, the generated data id is returned.
         * @summary Upload new data point.
         * @param {UploadedDataPoint} uploadedDataPoint 
         * @param {boolean} [bypassQa] If true, data is not sent to QA.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDataPoint: async (uploadedDataPoint: UploadedDataPoint, bypassQa?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uploadedDataPoint' is not null or undefined
            assertParamExists('postDataPoint', 'uploadedDataPoint', uploadedDataPoint)
            const localVarPath = `/data-points`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (bypassQa !== undefined) {
                localVarQueryParameter['bypassQa'] = bypassQa;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadedDataPoint, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The uploaded data point is verified to conform to its specification.
         * @summary Verify data point content against a given data point type.
         * @param {DataPointToValidate} dataPointToValidate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateDataPoint: async (dataPointToValidate: DataPointToValidate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataPointToValidate' is not null or undefined
            assertParamExists('validateDataPoint', 'dataPointToValidate', dataPointToValidate)
            const localVarPath = `/data-points/validator`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dataPointToValidate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DataPointControllerApi - functional programming interface
 */
export const DataPointControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DataPointControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * A data point identified by its ID is retrieved.
         * @summary Retrieve data points by ID.
         * @param {string} dataPointId The unique identifier of the datapoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDataPoint(dataPointId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadedDataPoint>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDataPoint(dataPointId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataPointControllerApi.getDataPoint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Meta-information about a data point identified by its ID is retrieved.
         * @summary Retrieve meta-information about data points by ID.
         * @param {string} dataPointId The unique identifier of the datapoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDataPointMetaInfo(dataPointId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataPointMetaInformation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDataPointMetaInfo(dataPointId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataPointControllerApi.getDataPointMetaInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The uploaded data point is added to the data store, the generated data id is returned.
         * @summary Upload new data point.
         * @param {UploadedDataPoint} uploadedDataPoint 
         * @param {boolean} [bypassQa] If true, data is not sent to QA.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDataPoint(uploadedDataPoint: UploadedDataPoint, bypassQa?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataPointMetaInformation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDataPoint(uploadedDataPoint, bypassQa, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataPointControllerApi.postDataPoint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The uploaded data point is verified to conform to its specification.
         * @summary Verify data point content against a given data point type.
         * @param {DataPointToValidate} dataPointToValidate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateDataPoint(dataPointToValidate: DataPointToValidate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateDataPoint(dataPointToValidate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataPointControllerApi.validateDataPoint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DataPointControllerApi - factory interface
 */
export const DataPointControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DataPointControllerApiFp(configuration)
    return {
        /**
         * A data point identified by its ID is retrieved.
         * @summary Retrieve data points by ID.
         * @param {string} dataPointId The unique identifier of the datapoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataPoint(dataPointId: string, options?: RawAxiosRequestConfig): AxiosPromise<UploadedDataPoint> {
            return localVarFp.getDataPoint(dataPointId, options).then((request) => request(axios, basePath));
        },
        /**
         * Meta-information about a data point identified by its ID is retrieved.
         * @summary Retrieve meta-information about data points by ID.
         * @param {string} dataPointId The unique identifier of the datapoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataPointMetaInfo(dataPointId: string, options?: RawAxiosRequestConfig): AxiosPromise<DataPointMetaInformation> {
            return localVarFp.getDataPointMetaInfo(dataPointId, options).then((request) => request(axios, basePath));
        },
        /**
         * The uploaded data point is added to the data store, the generated data id is returned.
         * @summary Upload new data point.
         * @param {UploadedDataPoint} uploadedDataPoint 
         * @param {boolean} [bypassQa] If true, data is not sent to QA.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDataPoint(uploadedDataPoint: UploadedDataPoint, bypassQa?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<DataPointMetaInformation> {
            return localVarFp.postDataPoint(uploadedDataPoint, bypassQa, options).then((request) => request(axios, basePath));
        },
        /**
         * The uploaded data point is verified to conform to its specification.
         * @summary Verify data point content against a given data point type.
         * @param {DataPointToValidate} dataPointToValidate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateDataPoint(dataPointToValidate: DataPointToValidate, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.validateDataPoint(dataPointToValidate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DataPointControllerApi - interface
 */
export interface DataPointControllerApiInterface {
    /**
     * A data point identified by its ID is retrieved.
     * @summary Retrieve data points by ID.
     * @param {string} dataPointId The unique identifier of the datapoint.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDataPoint(dataPointId: string, options?: RawAxiosRequestConfig): AxiosPromise<UploadedDataPoint>;

    /**
     * Meta-information about a data point identified by its ID is retrieved.
     * @summary Retrieve meta-information about data points by ID.
     * @param {string} dataPointId The unique identifier of the datapoint.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDataPointMetaInfo(dataPointId: string, options?: RawAxiosRequestConfig): AxiosPromise<DataPointMetaInformation>;

    /**
     * The uploaded data point is added to the data store, the generated data id is returned.
     * @summary Upload new data point.
     * @param {UploadedDataPoint} uploadedDataPoint 
     * @param {boolean} [bypassQa] If true, data is not sent to QA.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postDataPoint(uploadedDataPoint: UploadedDataPoint, bypassQa?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<DataPointMetaInformation>;

    /**
     * The uploaded data point is verified to conform to its specification.
     * @summary Verify data point content against a given data point type.
     * @param {DataPointToValidate} dataPointToValidate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    validateDataPoint(dataPointToValidate: DataPointToValidate, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * DataPointControllerApi - object-oriented interface
 */
export class DataPointControllerApi extends BaseAPI implements DataPointControllerApiInterface {
    /**
     * A data point identified by its ID is retrieved.
     * @summary Retrieve data points by ID.
     * @param {string} dataPointId The unique identifier of the datapoint.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDataPoint(dataPointId: string, options?: RawAxiosRequestConfig) {
        return DataPointControllerApiFp(this.configuration).getDataPoint(dataPointId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Meta-information about a data point identified by its ID is retrieved.
     * @summary Retrieve meta-information about data points by ID.
     * @param {string} dataPointId The unique identifier of the datapoint.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDataPointMetaInfo(dataPointId: string, options?: RawAxiosRequestConfig) {
        return DataPointControllerApiFp(this.configuration).getDataPointMetaInfo(dataPointId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The uploaded data point is added to the data store, the generated data id is returned.
     * @summary Upload new data point.
     * @param {UploadedDataPoint} uploadedDataPoint 
     * @param {boolean} [bypassQa] If true, data is not sent to QA.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postDataPoint(uploadedDataPoint: UploadedDataPoint, bypassQa?: boolean, options?: RawAxiosRequestConfig) {
        return DataPointControllerApiFp(this.configuration).postDataPoint(uploadedDataPoint, bypassQa, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The uploaded data point is verified to conform to its specification.
     * @summary Verify data point content against a given data point type.
     * @param {DataPointToValidate} dataPointToValidate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateDataPoint(dataPointToValidate: DataPointToValidate, options?: RawAxiosRequestConfig) {
        return DataPointControllerApiFp(this.configuration).validateDataPoint(dataPointToValidate, options).then((request) => request(this.axios, this.basePath));
    }
}

